const normalizeKdsStatus = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const toTimestamp = (value) => {
  const timestamp = new Date(value || "").getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
};

// Une mesure par ticket terminé, de la première prise en charge au dernier
// article prêt. Les lignes annulées/refusées et les horodatages incomplets ne
// doivent jamais fabriquer une moyenne artificielle.
export const computeAverageTicketPreparationMinutes = (rows = []) => {
  const tickets = new Map();

  for (const row of Array.isArray(rows) ? rows : []) {
    const courseStatus = String(row?.course_status || "fired")
      .trim()
      .toLowerCase();
    if (courseStatus === "held" || courseStatus === "cancelled") continue;
    const status = normalizeKdsStatus(row?.status);
    if (status === "cancelled" || row?.kds_rejected) continue;
    const orderId = Number(row?.order_id);
    if (!Number.isInteger(orderId) || orderId <= 0) continue;
    const courseKey = row?.course_id
      ? `course:${row.course_id}`
      : `course-number:${Number(row?.course_number) || 1}`;
    const destination = String(
      row?.destination || row?.product_destination_snapshot || "default",
    )
      .trim()
      .toLowerCase();
    const dispatchKind = String(row?.dispatch_kind || "").toLowerCase();
    const eventKey =
      dispatchKind === "addition" && Number(row?.dispatch_event_id) > 0
        ? `:dispatch:${Number(row.dispatch_event_id)}`
        : "";
    const ticketKey = `${orderId}:${courseKey}:${destination}${eventKey}`;
    const ticket = tickets.get(ticketKey) || [];
    ticket.push(row);
    tickets.set(ticketKey, ticket);
  }

  const durations = [];
  for (const items of tickets.values()) {
    if (!items.length) continue;
    if (
      !items.every((item) =>
        ["ready", "served"].includes(normalizeKdsStatus(item?.status)),
      )
    ) {
      continue;
    }
    const starts = items.map((item) =>
      toTimestamp(item?.preparation_started_at),
    );
    const ends = items.map((item) =>
      toTimestamp(item?.preparation_completed_at),
    );
    if (
      starts.some((value) => value == null) ||
      ends.some((value) => value == null)
    )
      continue;
    const startedAt = Math.min(...starts);
    const completedAt = Math.max(...ends);
    if (completedAt < startedAt) continue;
    durations.push((completedAt - startedAt) / 60000);
  }

  if (!durations.length) return null;
  return Math.max(
    0,
    Math.round(
      durations.reduce((sum, value) => sum + value, 0) / durations.length,
    ),
  );
};
